export default "__VITE_ASSET__Cbseew5Z__"